import { OutboundCallEntity } from '@lib/types/common-call-types';

export enum TabNameEnum {
  Employees = 'Employees',
  Queue = 'Queue',
  Keypad = 'Keypad',
}

export type OutboundCallDetails = {
  number: string;
  callDisplayName: string;
  /**
   * Identifies the type of entity being called (employee, queue, or keypad (external)).
   * Used primarily to determine the transfer type when transferring calls.
   */
  entity: OutboundCallEntity;
  agentId?: string;
  queueId?: string;
  loading?: boolean;
};

export type ITab = {
  value: TabNameEnum;
  selected?: boolean;
  disabled?: boolean;
};
